<template>
  <div class="layout-blog-post-card">
<!--    <div class="image">
      <slot name="image"></slot>
    </div>
    <div class="header">
      <div class="s-14 w-500"><slot name="date"></slot></div>
      <div class="s-14 w-500"><icon-eye></icon-eye> <slot name="views"></slot></div>
    </div>
    <div class="title s-18 w-600 cursor-pointer"><slot name="title"></slot></div>
    <div class="button"><slot name="button"></slot></div>-->

    <div class="image">
      <a :href="item.DETAIL_PAGE_URL">
        <img v-if="lazy && item.DETAIL_PICTURE && item.DETAIL_PICTURE.SRC" loading="lazy" :data-src="item.DETAIL_PICTURE.SRC" :alt="item.NAME">
        <img v-else-if="item.DETAIL_PICTURE && item.DETAIL_PICTURE.SRC" :src="item.DETAIL_PICTURE.SRC" :alt="item.NAME">
      </a>
    </div>
    <div class="header">
      <div class="s-14 w-500">{{ item.DATE }}</div>
      <div class="s-14 w-500"><icon-eye></icon-eye> {{ item.PROPERTIES.COUNT_VIEWED.VALUE }}</div>
    </div>
    <div class="title s-18 w-600 cursor-pointer">
      <a :href="item.DETAIL_PAGE_URL" slot="title">{{ item.NAME }}</a>
    </div>
    <div class="button">
      <a slot="button" :href="item.DETAIL_PAGE_URL">
        <ui-button rounded medium>Читать статью</ui-button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {},
    lazy: {
      type: Boolean,
      default: true
    }
  },
  components: {
    'icon-eye': () => import('@/components/icon/icon-eye.vue'),
    'ui-button': () => import('@/components/ui/ui-button'),
  }
}
</script>

<style lang="scss" scoped>
.layout-blog-post-card {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.image {
  position: relative;
  padding-bottom: 100%;
  overflow: hidden;
  border-radius: 7px;
  * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
}
.title {
  margin-bottom: 50px;
}
.button {
  margin-top: auto;
}
@media screen and (max-width: 767px) {
  .title {
    margin-bottom: 20px;
  }
}
</style>
